import { deleteApi, get, post } from "../GenericServices";

const CarUser = {
  getCarUsers: (queryString) => {
    return get(`car-user${queryString !== "" ? `?${queryString}` : ""}`);
  },
  getCarUser: (id) => {
    return get(`car-user/${id}`);
  },
  setCarUser: (data) => {
    return post(`car-user`, data);
  },
  deleteCarUser: (id) => {
    return deleteApi(`car-user/${id}`);
  },
};

export default CarUser;
